import moment from "moment";
import React, { useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import { useForm } from "../../common/FormCreator/helpers";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postGateForm } from "../../redux/actions/gateActions";

// import { #ADD_REDUX_ACTION# } from "../../redux/actions/#ADD_REDUX_ACTION#";// <-- TODO

const YearWorkHistoryForm = ({ appData, postGateFormFunc }) => {
  let initialWorkHistory = [
    {
      from: "",
      to: "",
      company: "",
      referee: "",
      address: "",
      telephone: "",
      email: "",
      reason: "",
      type: "",
    },
  ];
  const initialErrorMessages = [
    {
      toAfterFromDate: "",
      tooBigGap: "",
      keepOrder: "",
    },
  ];

  if (
    appData.gateOnboarding &&
    appData.gateOnboarding.workhistory &&
    appData.gateOnboarding.workhistory.workHistoryData
  ) {
    initialWorkHistory = Object.keys(
      appData.gateOnboarding.workhistory.workHistoryData
    ).map((key) => appData.gateOnboarding.workhistory.workHistoryData[key]);
  }

  const [workHistoryData, setWorkHistoryData] = useState(initialWorkHistory);
  const [validationErrorMessage, setValidationErrorMessage] =
    useState(initialErrorMessages);
  const [fiveYearsErrorMessage, setFiveYearsErrorMessage] = useState("");
  const [shouldDisable, setShouldDisable] = useState(true);

  const setValue = (value, key, i) => {
    const mappedHistoryData = workHistoryData.map((el, index) => {
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setWorkHistoryData(mappedHistoryData);
  };

  const removeLast = () => {
    const newArr = [...workHistoryData];
    newArr.splice(newArr.length - 1);
    setWorkHistoryData(newArr);
  };

  useEffect(() => {
    let areAllFieldsFilled = true;
    let areErrorMessagesEmpty = true;

    const validationMessages = workHistoryData.map(() => ({}));
    // check if there are no empty values
    workHistoryData.forEach((el) => {
      if (
        el.type === "ucb" ||
        el.type === "uncb" ||
        el.type === "travelling" ||
        el.type === "studying"
      ) {
        Object.keys(el).forEach((key) => {
          if (key !== "company" && key !== "reason") {
            if (!el[key]) {
              areAllFieldsFilled = false;
            }
          }
        });
      } else {
        Object.keys(el).forEach((key) => {
          if (!el[key]) {
            areAllFieldsFilled = false;
          }
        });
      }
    });

    if (workHistoryData[0].to && workHistoryData[0].from) {
      let oldestDate = moment(workHistoryData[0].to).format("YYYY-MM-DD");
      let earliestDate = moment(workHistoryData[0].from).format("YYYY-MM-DD");

      workHistoryData.forEach((el, i) => {
        const from = el.from ? moment(el.from).format("YYYY-MM-DD") : null;
        const to = el.to ? moment(el.to).format("YYYY-MM-DD") : null;

        // Validation if 'from' date is before 'to' date validation
        if (from && to && moment(to).isBefore(from)) {
          const prev = validationMessages[i] ? validationMessages[i] : {};
          validationMessages[i] = {
            ...prev,
            toAfterFromDate: "From date can not be after to date",
          };
        }

        if (from && moment(from).isBefore(oldestDate)) {
          oldestDate = from;
        }

        if (to && moment(to).isAfter(earliestDate)) {
          earliestDate = to;
        }
      });

      // Validation whole time (min 5 years /(- 28 days))
      if (oldestDate && earliestDate) {
        const r = moment(earliestDate).diff(moment(oldestDate), "years", true);

        if (!(r >= 4.924731182795699)) {
          setFiveYearsErrorMessage(
            "Please ensure the work history you have entered covers the last 5 years."
          );
        } else {
          setFiveYearsErrorMessage("");
        }
      }

      // Validation difference in time between jobs (max 28 days)
      for (let i = 0; workHistoryData.length - 1; i += 1) {
        if (i === workHistoryData.length - 1) {
          break;
        }
        if (
          workHistoryData[i + 1].from &&
          workHistoryData[i + 1].to &&
          workHistoryData[i].from &&
          workHistoryData[i].to
        ) {
          const start = moment(workHistoryData[i + 1].to, "YYYY/MM/DD");
          const end = moment(workHistoryData[i].from, "YYYY/MM/DD");
          const r = moment(end).diff(moment(start), "days", true);

          const startDESC = moment(workHistoryData[i].to, "YYYY/MM/DD");
          const endDESC = moment(workHistoryData[i + 1].from, "YYYY/MM/DD");
          const rDESC = moment(endDESC).diff(moment(startDESC), "days", true);

          if (r > 28 || rDESC > 28) {
            const prev = validationMessages[i + 1]
              ? validationMessages[i + 1]
              : {};
            validationMessages[i + 1] = {
              ...prev,
              tooBigGap:
                "You have a gap of more than 28 days in comparison with the last job you entered, please amend as we can not accept a gap of more than 28 days without details of a character reference to contact.",
              keepOrder:
                "Please ensure your work history is in chronological order so we can validate your dates.",
            };
          }
        }
      }
    }

    validationMessages.forEach((el) => {
      Object.keys(el).forEach((key) => {
        if (el[key] && Object.keys(el[key]).length > 0) {
          areErrorMessagesEmpty = false;
        }
      });
    });

    setValidationErrorMessage(validationMessages);

    if (
      areAllFieldsFilled &&
      areErrorMessagesEmpty &&
      fiveYearsErrorMessage === ""
    ) {
      setShouldDisable(false);
    } else {
      setShouldDisable(true);
    }
  }, [shouldDisable, workHistoryData, fiveYearsErrorMessage]);

  const initialState = {
    YearWorkHistoryForm1: {
      title: "",
      type: "heading",
      textDescription: [
        "Due to Civil Aviation Authority regulations we require a comprehensive account of your continuous employment and/or education history for the last 5 years. This includes all periods of unemployment and periods of travel abroad that lasted 28 days or longer.",
        "For referencing purposes it is vital that you provide us with complete and accurate information regarding your five year history. Each entry must include the full name of the Company, School, University (etc...), full postal address, a contact name and a contact method (telephone number and/or email address).",
        "Periods of unemployment will not affect your possibility of employment with Gate Group but must be declared as part of your five-year history. Civil Aviation Authority regulations require us to establish that potential employees have been seen at least once every 28 days. Consequently, we need to capture any periods of unemployment you have had within the last five years that lasted 28 days or longer. If you were claiming Job Seekers Allowance (JSA) at any point whilst unemployed you will need to obtain a Statement of Benefit in order to meet referencing standards. Please provide details of the Job Centre you were registered at below. For periods where you were unemployed for more than 28 days and not claiming JSA we will approach a personal (gap) reference of your choice.",
        "Please include all periods of employment, unemployment, education and travel over the last 5 years below, starting with the most recent. Please note a failure to supply sufficient information will result in us being unable to progress your application.",
      ],
    },
    YearWorkHistoryForm2: {
      type: "workHistory",
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    postGateFormFunc("workhistory", {
      workHistoryData,
    });

    history.push("/profile/edit/gate-group-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"5 Year Work History"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/gate-group-onboarding")}
      onboardingBranch={"#ADD_BRANCH#"} // <-- TODO
      setValue={setValue}
      removeLast={removeLast}
      workHistoryData={workHistoryData}
      setWorkHistoryData={setWorkHistoryData}
      validationErrorMessage={validationErrorMessage}
      setFiveYearsErrorMessage={setFiveYearsErrorMessage}
      fiveYearsErrorMessage={fiveYearsErrorMessage}
      shouldDisable={shouldDisable}
    />
  );
};

YearWorkHistoryForm.propTypes = {
  appData: any,
  postGateFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  postGateFormFunc: postGateForm,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(YearWorkHistoryForm);
